import { KBDocument } from '../../types';

export const symptomTrackingBestPractices: KBDocument = {
  id: 'placeholder-symptom-tracking',
  title: '[PLACEHOLDER] Getting more out of a symptom log — general background',
  source: 'Placeholder demo content — not yet curated',
  placeholder: true,
  text: `Symptom logs tend to be most useful for spotting patterns when they're kept consistently
rather than only on bad days — logging "no symptoms" days gives the same pattern-detection
value as logging symptomatic ones. Recording context factors alongside symptoms (sleep, stress,
exercise, medication) makes it easier to spot correlations rather than just frequency.

When preparing for a doctor's visit, a log that highlights when symptoms started, how they've
changed over time, and what seems to make them better or worse is generally more useful than a
simple symptom list. This is general background information, not medical advice for any
individual situation.`
};
